import SLSTipoPedidoService from '@/services/SistemaDKP/SLSTipoPedido.service';
import { isPerfilClienteAtivo } from '@/libs/perfilCliente';

// Perfil Cliente NUNCA usa Doação (WD): só Venda (WS) e Certificação (WC).
// A separação de doação acontece apenas no fluxo interno (Operação).
const tipoProibidoParaCliente = (id) => {
  try {
    return isPerfilClienteAtivo() && String(id || '').toUpperCase() === 'WD';
  } catch (e) {
    return false;
  }
};
const slsTipoPedidoService = new SLSTipoPedidoService();
// The backend resolves somentePermitidos from the ACTIVE profile in the token.
// Never reuse a previous profile's options while another request is pending.
const perfilTiposAtivo = () => {
  try {
    return localStorage.getItem('perfilLogado') || '';
  } catch (e) {
    return '';
  }
};

export default {
  namespaced: true,
  state: () => ({
    clienteData: null,
    enderecoEntrega: null,
    // Endereço de entrega alternativo escolhido pelo usuário (cliente sem
    // endereço padrão) — {endereco,numero,complemento,bairro,cidade,uf,cep}
    enderecoAlternativo: null,
    dataCapaPedido: null,
    cacheRepresentantes: null,
    isConfirmarPedido: false,
    itemSelected: null,
    itemPromocaoSelected: null,
    formInfoPedido: {
      dataPrevistaEntrega: null,
      cdn_embalag: null,
      cliente: {
        clienteid: '',
        clienteiderp: '',
        uuid: '',
        condicaopagamentoid: '',
        clientetipopessoa: '',
        clientenomeabreviado: '',
        clientenomematriz: '',
        clientenomefantasia: '',
        clienterazaosocial: '',
        clientecnpj: '',
        clienteisentoie: '',
        clienteie: '',
      },
      representante: {
        representanteid: null,
        representantenomeabreviado: '',
        representantenome: '',
        representanteemail: '',
        representanteseqpedido: '',
        representanteativo: '',
        representanteendereco: '',
        representantebairro: '',
        representantecidade: '',
        ufid: null,
        paisid: null,
        representantepercentualcomissao: '',
      },
      prioridadesPedido: null,
      clienteIdErp: null,
      enderecoEntrega: null,
      canalVenda: null,
      estabelecimento: {
        estabelecimentoid: '',
        estabelecimentorazaosocial: '',
      },
      tabelaPreco: {
        tabelapreco_id: null,
        tabelapreco_descricao: '',
      },
      tipoPedidoCliente: {
        tipopedidoid: null,
        tipopedidodescricao: null,
      },
      condicaoPagamento: {
        condicaopagamentoid: null,
        condicaopagamentodescricao: null,
      },
      numeroPedidoOrderCompra: null,
      idNexus: '',
      picPedido: null,
      optionsPicPedido: [],
      observacao: null,
    },
    filters: {
      page: 1,
      perPage: 10,
      sortBy: 'id',
      sortDesc: null,
      total: 0,
    },
    tipoPedidos: [],
    tipoPedidosPerfil: null,
    tipoPedidosRequestId: 0,
    loadingTipoPedidos: false,
    erroTipoPedidos: null,
    optionsCodPagamento: [],
    optionsTabelaPreco: [],
    optionsTipoPedidoCliente: [],
    loadingRepresentante: false,
    loadingCliente: false,
    loadingCondPagamento: false,
    loadingTabelaPreco: false,
    isLoading: false,
    representanteReadonly: false,
    clienteReadonly: false,
  }),
  mutations: {
    SET_REPRESENTANTE_READONLY(state, payload) {
      state.representanteReadonly = payload;
    },
    SET_CLIENTE_READONLY(state, payload) {
      state.clienteReadonly = payload;
    },
    SET_CLIENTE_DATA(state, payload) {
      state.clienteData = payload.clienteData;
      state.enderecoEntrega = payload.enderecoEntrega;
      state.dataCapaPedido = payload.dataCapaPedido;
      // Novo cliente → endereço alternativo do anterior não vale mais.
      state.enderecoAlternativo = null;
    },
    SET_ENDERECO_ALTERNATIVO(state, payload) {
      state.enderecoAlternativo = payload || null;
    },
    SET_CACHE_REPRESENTANTES(state, representantes) {
      state.cacheRepresentantes = representantes;
    },
    SET_IS_CONFIRMA_PEDIDO(state, payload) {
      state.isConfirmarPedido = payload;
    },
    SET_TIPO_PEDIDOS(state, payload) {
      // Cliente: remove Doação (WD) da lista, mesmo que o backend a envie.
      if (Array.isArray(payload)) {
        payload = payload.filter((t) => !t || !tipoProibidoParaCliente(t.value));
      }
      state.tipoPedidos = payload;
      // Auto-correção: se o tipo selecionado não existir na nova lista de
      // permitidos (ex.: WS ficou selecionado por um carregamento anterior,
      // mas o perfil só tem WD), troca para WS ou o primeiro tipo real —
      // evita o select ficar em branco com um valor órfão.
      const opcoes = (payload || []).filter((t) => t && t.value !== null && t.value !== undefined && t.value !== '');
      if (opcoes.length === 0) {
        state.formInfoPedido.tipoPedidoCliente = { tipopedidoid: null, tipopedidodescricao: null };
        return;
      }
      const atual = state.formInfoPedido && state.formInfoPedido.tipoPedidoCliente;
      const atualValido = atual && atual.tipopedidoid
        && opcoes.some((t) => String(t.value).toUpperCase() === String(atual.tipopedidoid).toUpperCase());
      if (!atualValido) {
        const padrao = opcoes.find((t) => String(t.value).toUpperCase() === 'WS') || opcoes[0];
        state.formInfoPedido.tipoPedidoCliente = {
          tipopedidoid: padrao.value,
          tipopedidodescricao: padrao.text,
        };
      }
    },
    SET_FORM_INFO_PEDIDO(state, payload) {
      // Preserva o Tipo de Pedido já escolhido (ou o padrão) quando o payload
      // não traz um tipo válido — evita que selecionar representante/cliente,
      // ou resets parciais, "desselecionem" o tipo de pedido.
      const incoming = payload.tipoPedidoCliente;
      const incomingValido = incoming
        && incoming.tipopedidoid !== null
        && incoming.tipopedidoid !== undefined
        && incoming.tipopedidoid !== ''
        && !tipoProibidoParaCliente(incoming.tipopedidoid)
        && (state.tipoPedidosPerfil !== perfilTiposAtivo() || state.loadingTipoPedidos
          || (state.tipoPedidos || []).some((t) => t && String(t.value).toUpperCase() === String(incoming.tipopedidoid).toUpperCase()));
      const atual = state.formInfoPedido && state.formInfoPedido.tipoPedidoCliente;
      const atualPermitido = atual && (state.tipoPedidos || []).some((t) => t && String(t.value).toUpperCase() === String(atual.tipopedidoid).toUpperCase());
      const padrao = (state.tipoPedidos || []).find((t) => t && String(t.value).toUpperCase() === 'WS')
        || (state.tipoPedidos || []).find((t) => t && t.value);
      state.formInfoPedido = {
        ...payload,
        tipoPedidoCliente: incomingValido
          ? incoming
          : (state.tipoPedidosPerfil === perfilTiposAtivo() && !state.loadingTipoPedidos
            ? (atualPermitido ? atual : (padrao
              ? { tipopedidoid: padrao.value, tipopedidodescricao: padrao.text }
              : { tipopedidoid: null, tipopedidodescricao: null }))
            : (atual || { tipopedidoid: null, tipopedidodescricao: null })),
      };
    },
    SET_FILTERS(state, payload) {
      state.filters = payload;
    },
    SET_IS_LOADING(state, payload) {
      state.isLoading = payload;
    },
    SET_REPRESENTANTE_FORM(state, payload) {
      state.formInfoPedido.representante = payload;
    },
    SET_CLIENTE_FORM(state, payload) {
      state.formInfoPedido.cliente = payload;
    },
    SET_PRIORIDADE_PEDIDO_FORM(state, payload) {
      state.formInfoPedido.prioridadesPedido = payload;
    },
    SET_CLIENTE_ID_ERP(state, payload) {
      state.formInfoPedido.clienteIdErp = payload;
    },
    SET_TIPO_ENDERECO_ID(state, payload) {
      state.formInfoPedido.tipoEnderecoId = payload;
    },
    SET_ENDERECO_ENTREGA(state, payload) {
      state.formInfoPedido.enderecoEntrega = payload;
    },
    SET_CANAIS_VENDA(state, payload) {
      state.formInfoPedido.canalVenda = payload;
    },
    SET_ESTABELECIMENTO(state, payload) {
      state.formInfoPedido.estabelecimento = payload;
    },
    SET_TABELA_PRECO(state, payload) {
      state.formInfoPedido.tabelaPreco = payload;
    },
    SET_LOADING_REPRESENTANTE(state, payload) {
      state.loadingRepresentante = payload;
    },
    SET_LOADING_CLIENTE(state, payload) {
      state.loadingCliente = payload;
    },
    SET_OPTIONS_COND_PAGAMENTO(state, payload) {
      state.optionsCodPagamento = payload;
    },
    SET_OPTIONS_TABELA_PRECO(state, payload) {
      state.optionsTabelaPreco = payload;
    },
    SET_LOADING_COND_PAGAMENTO(state, payload) {
      state.loadingCondPagamento = payload;
    },
    SET_LOADING_TABELA_PRECO(state, payload) {
      state.loadingTabelaPreco = payload;
    },
    SET_CONDICAO_PAGAMENTO_FORM(state, payload) {
      state.formInfoPedido.condicaoPagamento = payload;
    },
    SET_DATA_PREVISTA_ENTREGA_FORM(state, payload) {
      state.formInfoPedido.dataPrevistaEntrega = payload;
    },
    SET_NUMERO_PEDIDO_ORDER_COMPRA_FORM(state, payload) {
      state.formInfoPedido.numeroPedidoOrderCompra = payload;
    },
    SET_ITEM_SELECTED(state, payload) {
      state.itemSelected = payload;
    },
    SET_ITEM_PROMOCAO_SELECTED(state, payload) {
      state.itemPromocaoSelected = payload;
    },
    SET_EMBALEGEM_FORM(state, payload) {
      state.formInfoPedido.cdn_embalag = payload;
    },
    SET_TIPO_PEDIDO_CLIENTE(state, payload) {
      // Cliente nunca pode ficar com Doação (WD) selecionada — troca por
      // Venda (WS) da lista de permitidos, ou o primeiro tipo real.
      if (payload && tipoProibidoParaCliente(payload.tipopedidoid)) {
        const opcoes = (state.tipoPedidos || []).filter((t) => t && t.value && String(t.value).toUpperCase() !== 'WD');
        const padrao = opcoes.find((t) => String(t.value).toUpperCase() === 'WS') || opcoes[0];
        payload = padrao
          ? { tipopedidoid: padrao.value, tipopedidodescricao: padrao.text }
          : { tipopedidoid: null, tipopedidodescricao: null };
      }
      state.formInfoPedido.tipoPedidoCliente = payload;
    },
    SET_OPTIONS_TIPO_PEDIDO_CLIENTE(state, payload) {
      state.optionsTipoPedidoCliente = payload;
    },
    INICIAR_CARGA_TIPOS_PEDIDO(state, perfil) {
      state.tipoPedidosRequestId += 1;
      if (state.tipoPedidosPerfil !== perfil) {
        state.tipoPedidos = [];
        state.formInfoPedido.tipoPedidoCliente = { tipopedidoid: null, tipopedidodescricao: null };
      }
      state.tipoPedidosPerfil = perfil;
      state.loadingTipoPedidos = true;
      state.erroTipoPedidos = null;
    },
    FINALIZAR_CARGA_TIPOS_PEDIDO(state, erro) {
      state.loadingTipoPedidos = false;
      state.erroTipoPedidos = erro;
    },
    SET_OPTIONS_PIC_PEDIDO(state, payload) {
      state.formInfoPedido.optionsPicPedido = payload;
    },
    SET_PIC_PEDIDO(state, payload) {
      state.formInfoPedido.picPedido = payload;
    },
  },
  getters: {
    GET_CLIENTE_DATA: (state) => state.clienteData,
    GET_ENDERECO_ENTREGA: (state) => state.enderecoEntrega,
    GET_ENDERECO_ALTERNATIVO: (state) => state.enderecoAlternativo,
    GET_DATA_CAPA_PEDIDO: (state) => state.dataCapaPedido,
    GET_COND_PAGTOS_FORM(state) {
      return state.formInfoPedido.condicaoPagamento;
    },
    GET_FORM_INFO_PEDIDO(state) {
      return state.formInfoPedido;
    },
    GET_FILTERS(state) {
      return state.filters;
    },
    GET_IS_LOADING(state) {
      return state.isLoading;
    },
    GET_TIPO_PEDIDOS_CLIENTE(state) {
      return state.tipoPedidos;
    },
    GET_LOADING_TIPO_PEDIDOS: (state) => state.loadingTipoPedidos,
    GET_ERRO_TIPO_PEDIDOS: (state) => state.erroTipoPedidos,
    GET_LOADING_REPRESENTANTE(state) {
      return state.loadingRepresentante;
    },
    GET_LOADING_CLIENTE(state) {
      return state.loadingCliente;
    },
    GET_LOADING_COND_PAGAMENTO(state) {
      return state.loadingCondPagamento;
    },
    GET_LOADING_TABELA_PRECO(state) {
      return state.loadingTabelaPreco;
    },
    GET_OPTIONS_TABELA_PRECO(state) {
      return state.optionsTabelaPreco;
    },
    GET_OPTIONS_CONDICAO_PAGAMENTO(state) {
      return state.optionsCodPagamento;
    },
    GET_OPTIONS_TIPO_PEDIDO_CLIENTE(state) {
      return state.formInfoPedido.tipoPedido;
    },
    GET_CLIENT_ID_ERP(state) {
      return state.formInfoPedido.cliente;
    },
    GET_CLIENTE_ID(state) {
      return state.formInfoPedido.cliente.clienteid;
    },
    GET_REPRESENTANTE_ID(state) {
      return state.formInfoPedido.representante.representanteid;
    },
    GET_IS_CONFIRMAR_PEDIDO(state) {
      return state.isConfirmarPedido;
    },
    GET_VALIDATION_FORM_INFO_PEDIDO(state, getters, rootState, rootGetters = {}) {
      const clienteExists = state.formInfoPedido && state.formInfoPedido.cliente;
      const representanteExists = state.formInfoPedido && state.formInfoPedido.representante;
      const tabelaPrecoExists = state.formInfoPedido && state.formInfoPedido.tabelaPreco;
      const condicaoPagamentoExists = state.formInfoPedido && state.formInfoPedido.condicaoPagamento;
      const tipoPedidoExists = state.formInfoPedido && state.formInfoPedido.tipoPedidoCliente;
      const representanteValido = isPerfilClienteAtivo()
        || (representanteExists && state.formInfoPedido.representante.representanteid);
      const condicaoValida = rootGetters['preferencias/condicaoPagamentoAtiva'] === false
        || (condicaoPagamentoExists && state.formInfoPedido.condicaoPagamento.condicaopagamentoid);
      const validatinPedido = clienteExists && state.formInfoPedido.cliente.clienteid
                && representanteValido
                && tabelaPrecoExists && state.formInfoPedido.tabelaPreco.tabelapreco_id
                && condicaoValida
                && tipoPedidoExists && state.formInfoPedido.tipoPedidoCliente.tipopedidoid;
      return !!validatinPedido;
    },
    GET_DATA_PREVISTA_ENTREGA_FORM(state) {
      return state.formInfoPedido.dataPrevistaEntrega;
    },
    GET_NUMERO_PEDIDO_ORDER_COMPRA_FORM(state) {
      return state.formInfoPedido.numeroPedidoOrderCompra;
    },
    GET_ITEM_SELECTED(state) {
      return state.itemSelected;
    },
    GET_ITEM_PROMOCAO_SELECTED(state) {
      return state.itemPromocaoSelected;
    },
    GET_EMBALAGEM_FORM(state) {
      return state.formInfoPedido.cdn_embalag;
    },
    GET_TABELE_PRECO_FORM(state) {
      return state.formInfoPedido.tabelaPreco;
    },
    GET_OPTIONS_PIC_PEDIDO(state) {
      return state.formInfoPedido.optionsPicPedido;
    },
    GET_PIC_PEDIDO(state) {
      return state.formInfoPedido.picPedido;
    },
  },
  actions: {
    async carregarTiposPedidoPermitidos({ state, commit }) {
      const perfil = perfilTiposAtivo();
      commit('INICIAR_CARGA_TIPOS_PEDIDO', perfil);
      const requestId = state.tipoPedidosRequestId;
      try {
        const response = await slsTipoPedidoService.index({ perPage: 100, somentePermitidos: 1 });
        if (!response || !Array.isArray(Array.isArray(response) ? response : response.data)) {
          throw new Error('Não foi possível carregar os tipos de pedido permitidos.');
        }
        if (requestId !== state.tipoPedidosRequestId || perfil !== perfilTiposAtivo()) return;
        const items = Array.isArray(response) ? response : response.data;
        commit('SET_TIPO_PEDIDOS', [
          { value: null, text: 'Selecione o tipo de pedido' },
          ...items.map((item) => ({
            value: item.tipopedidoid,
            text: `${item.tipopedidoid} - ${item.tipopedidodescricao}`,
          })),
        ]);
        commit('FINALIZAR_CARGA_TIPOS_PEDIDO', items.length ? null : 'Nenhum tipo de pedido permitido para o perfil ativo.');
      } catch (error) {
        if (requestId !== state.tipoPedidosRequestId || perfil !== perfilTiposAtivo()) return;
        commit('SET_TIPO_PEDIDOS', []);
        commit('FINALIZAR_CARGA_TIPOS_PEDIDO', 'Não foi possível carregar os tipos de pedido permitidos. Tente novamente.');
        console.error('Erro ao carregar tipos de pedido permitidos:', error);
      }
    },
    async prepararModalEmbalagens({ commit, state, dispatch }) {
      if (!state.itemSelected || !state.itemPromocaoSelected) {
        await dispatch('carregarDadosProduto', state.itemSelected);
      }
    },
    async carregarDadosProduto({ commit }, produtoId) {
      const dadosProduto = await produtoService.buscarProduto(produtoId);
      commit('SET_ITEM_SELECTED', dadosProduto.itemSelected);
      commit('SET_ITEM_PROMOCAO_SELECTED', dadosProduto.itemPromocaoSelected);
    },
    async listarRepresentanteInfoPedido({ commit, state }) {
      if (!state.cacheRepresentantes) {
        const representantes = await slsRepresentanteService.listarRepresentanteInfoPedido();
        commit('SET_CACHE_REPRESENTANTES', representantes);
      }
      return state.cacheRepresentantes;
    },
    resetarRepresentanteInfoPedido({ commit }) {
      commit('SET_REPRESENTANTE_FORM', {
        representanteid: null,
        representantenomeabreviado: '',
        representantenome: '',
        representanteemail: '',
        representanteseqpedido: '',
        representanteativo: '',
        representanteendereco: '',
        representantebairro: '',
        representantecidade: '',
        ufid: null,
        paisid: null,
        representantepercentualcomissao: '',
      });
    },
    resetarClienteInfoPedido({ commit, state }) {
      console.log('resetarClienteInfoPedido');
      commit('SET_FORM_INFO_PEDIDO', {
        ...state.formInfoPedido,
        cliente: {
          clienteid: '',
          clienteiderp: '',
          uuid: '',
          condicaopagamentoid: '',
          clientetipopessoa: '',
          clientenomeabreviado: '',
          clientenomematriz: '',
          clientenomefantasia: '',
          clienterazaosocial: '',
          clientecnpj: '',
          clienteisentoie: '',
          clienteie: '',
        },
        // representante: { ...state.representante },
        prioridadesPedido: null,
        clienteIdErp: null,
        enderecoEntrega: null,
        canalVenda: null,
        estabelecimento: {
          estabelecimentoid: '',
          estabelecimentorazaosocial: '',
        },
        tabelaPreco: {
          tabelapreco_id: null,
          tabelapreco_descricao: '',
        },
        tipoPedidoCliente: {
          tipopedidoid: null,
          tipopedidodescricao: null,
        },
        condicaoPagamento: {
          condicaopagamentoid: null,
          condicaopagamentodescricao: null,
        },
        numeroPedidoOrderCompra: null,
        idNexus: '',
        picPedido: null,
        optionsPicPedido: [],
        observacao: null,
      });
    },
    resetarTabelaPrecoInfoPedido({ commit }) {
      commit('SET_TABELA_PRECO', {
        tabelapreco_id: null,
        tabelapreco_descricao: '',
      });
      commit('SET_OPTIONS_TABELA_PRECO', []);
    },
    resertCondPagamentoInfoPedido({ commit }) {
      commit('SET_CONDICAO_PAGAMENTO_FORM', {
        condicaopagamentoid: null,
        condicaopagamentodescricao: null,
      });
      commit('SET_OPTIONS_COND_PAGAMENTO', []);
    },
    resertInfoPedido({ commit, state, dispatch }) {
      dispatch('resetarRepresentanteInfoPedido');
      commit('SET_FORM_INFO_PEDIDO', {
        dataPrevistaEntrega: null,
        cliente: {
          clienteid: '',
          clienteiderp: '',
          uuid: '',
          condicaopagamentoid: '',
          clientetipopessoa: '',
          clientenomeabreviado: '',
          clientenomematriz: '',
          clientenomefantasia: '',
          clienterazaosocial: '',
          clientecnpj: '',
          clienteisentoie: '',
          clienteie: '',
        },
        representante: state.formInfoPedido.representante || {
          representanteid: null,
          representantenomeabreviado: '',
          representantenome: '',
          representanteemail: '',
          representanteseqpedido: '',
          representanteativo: '',
          representanteendereco: '',
          representantebairro: '',
          representantecidade: '',
          ufid: null,
          paisid: null,
          representantepercentualcomissao: '',
        },
        prioridadesPedido: null,
        clienteIdErp: null,
        enderecoEntrega: null,
        canalVenda: null,
        estabelecimento: {
          estabelecimentoid: '',
          estabelecimentorazaosocial: '',
        },
        tabelaPreco: {
          tabelapreco_id: null,
          tabelapreco_descricao: '',
        },
        condicaoPagamento: {
          condicaopagamentoid: null,
          condicaopagamentodescricao: null,
        },
        numeroPedidoOrderCompra: null,
        idNexus: '',
        observacao: null,
      });
      // Reset completo ("Limpar"): restaura o Tipo de Pedido para o padrão WS,
      // de forma determinística (a preservação do mutation só vale para resets
      // parciais). Se o perfil não tiver o WS entre os permitidos, usa o
      // primeiro tipo real da lista (ignora o placeholder value=null).
      const opcoes = (state.tipoPedidos || []).filter((t) => t && t.value !== null && t.value !== undefined && t.value !== '');
      const padrao = opcoes.find((t) => String(t.value).toUpperCase() === 'WS') || opcoes[0];
      commit('SET_TIPO_PEDIDO_CLIENTE', padrao
        ? { tipopedidoid: padrao.value, tipopedidodescricao: padrao.text }
        : { tipopedidoid: null, tipopedidodescricao: null });
    },
    // Garante que o Tipo de Pedido nunca fique "desselecionado" — independente
    // do InfoPedido.vue estar montado. Carrega a lista de tipos permitidos se
    // necessário e aplica WS (Venda Padrão) ou o primeiro tipo disponível.
    // Chamado no login (InitialData), na home (catálogo) e no carrinho.
    async garantirTipoPedidoDefault({ state, commit, dispatch }) {
      const extrairOpcoes = () => (state.tipoPedidos || [])
        .filter((t) => t && t.value !== null && t.value !== undefined && t.value !== '');
      // Se já há um tipo selecionado E ele é válido perante as opções já
      // carregadas, nada a fazer. Se as opções ainda não foram carregadas,
      // NÃO confiar cegamente na seleção atual — ela pode ter vindo de um
      // carregamento com outro perfil (ex.: WS para um representante que só
      // tem WD). Carrega a lista de permitidos e valida.
      const atualEhValido = () => {
        const ops = extrairOpcoes();
        const atual = state.formInfoPedido && state.formInfoPedido.tipoPedidoCliente;
        return atual && atual.tipopedidoid
          && ops.some((t) => String(t.value).toUpperCase() === String(atual.tipopedidoid).toUpperCase());
      };
      if (state.tipoPedidosPerfil !== perfilTiposAtivo() || extrairOpcoes().length === 0) {
        await dispatch('carregarTiposPedidoPermitidos');
      }
      if (atualEhValido()) return;
      const opcoes = extrairOpcoes();
      if (opcoes.length === 0) return;
      // Revalida após carregar as opções: se a seleção atual é válida agora
      // (ou já foi corrigida pela mutation SET_TIPO_PEDIDOS), não sobrescreve.
      if (atualEhValido()) return;
      const padrao = opcoes.find((t) => String(t.value).toUpperCase() === 'WS') || opcoes[0];
      if (padrao) {
        commit('SET_TIPO_PEDIDO_CLIENTE', {
          tipopedidoid: padrao.value,
          tipopedidodescricao: padrao.text,
        });
      }
    },
  },
};
